import { createSelector } from '@reduxjs/toolkit';

import { BANNER_VARIANT, CONNECTION_QUALITY, CONNECTION_STATUS } from '../constants';

const selectConnectivityRoot = (state) => state.connectivity;

export const selectConnectionStatus = (state) =>
    selectConnectivityRoot(state)?.status ?? CONNECTION_STATUS.ONLINE;

export const selectConnectionQuality = (state) =>
    selectConnectivityRoot(state)?.quality ?? CONNECTION_QUALITY.GOOD;

export const selectHasFullscreenLayer = (state) =>
    Boolean(selectConnectivityRoot(state)?.fullscreenLayer);

const selectHasAnalysisScreen = (state) => Boolean(selectConnectivityRoot(state)?.analysisScreen);

const STATUS_VARIANT = {
    [CONNECTION_STATUS.OFFLINE]: BANNER_VARIANT.OFFLINE,
    [CONNECTION_STATUS.RECONNECTING]: BANNER_VARIANT.RECONNECTING,
    [CONNECTION_STATUS.BACK_ONLINE]: BANNER_VARIANT.BACK_ONLINE,
};

// Offline > Reconnecting > Back online > Slow. `null` hides the banner. Over a loading screen, slow
// shows as the hint card under its spinner instead.
export const selectBannerVariant = createSelector(
    [selectConnectionStatus, selectConnectionQuality, selectHasAnalysisScreen],
    (status, quality, hasAnalysisScreen) => {
        if (STATUS_VARIANT[status]) return STATUS_VARIANT[status];
        if (hasAnalysisScreen) return null;
        return quality === CONNECTION_QUALITY.SLOW ? BANNER_VARIANT.SLOW : null;
    }
);
